import React from 'react'
import PropTypes from 'prop-types'
import { normalizeImage, base64ToHex } from '../../../lib/image_utils'
import {
  ALLOWED_IMAGE_TYPES,
  UNALLOWED_ENCODED_IMAGE_TYPES,
  COVER_IMAGE_UPLOAD_ERRORS,
} from 'shared/shared_consts'

class ImageFileField extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    onChange: PropTypes.func,
    onError: PropTypes.func,
    restrictedTotalSize: PropTypes.number,
    onImageLoad: PropTypes.func,
  }

  handleOpenFileDialog = () => {
    this.input.click()
  }

  handleFileSelect = fileSelectEvent => {
    const fileReader = new FileReader()
    const file = fileSelectEvent.target.files[0]
    this.props.onImageLoad(true)
    fileReader.onload = onLoadEvent => {
      const url = onLoadEvent.target.result
      // Get file signature from magic bytes
      const magicNumber = url.split('base64,')[1].slice(0, 6)
      const fileSignature = base64ToHex(magicNumber)
      // Look for specific unallowed file types using file signature
      if (UNALLOWED_ENCODED_IMAGE_TYPES.includes(fileSignature)) {
        const error = { code: COVER_IMAGE_UPLOAD_ERRORS.FILE_INVALID_TYPE }
        if (this.props.onError) {
          this.props.onError(error)
        }
        this.props.onImageLoad(false)
        return null
      }
      const options = { mimeType: file.type }
      if (this.props.onChange) {
        if (this.props.restrictedTotalSize) {
          const restrictedSize = this.props.restrictedTotalSize
          options.normalizeImageSize = true
          normalizeImage(
            url,
            restrictedSize,
            restrictedSize,
            options,
            normalizedUrl => {
              this.props.onChange({
                url: normalizedUrl,
                name: file && file.name,
              })
              this.props.onImageLoad(false)
            }
          )
        } else {
          normalizeImage(url, null, null, options, normalizedUrl => {
            this.props.onChange({ url: normalizedUrl, name: file && file.name })
            this.props.onImageLoad(false)
          })
        }
      }
      this.props.onImageLoad(false)
    }
    if (file) {
      fileReader.readAsDataURL(file)
    }
  }

  render() {
    return (
      <div onClick={this.handleOpenFileDialog}>
        {this.props.children}
        <input
          style={{ display: 'none' }}
          type="file"
          accept={ALLOWED_IMAGE_TYPES}
          ref={input => {
            this.input = input
          }}
          onChange={this.handleFileSelect}
        />
      </div>
    )
  }
}

export default ImageFileField
